import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { ContentBlockBaseComponent } from '../content-block-base/content-block-base.component';
import { groupFaqs } from 'src/app/faq/store';
import { exampleFaqs } from 'src/app/styleguide/exampledata/example-entities';
import { FaqSectionComponent } from 'src/app/faq/components/faq-section/faq-section.component';

import { FaqCategory, FaqItem } from 'src/app/faq/models';
import { Department } from 'src/app/location/models';

@Component({
    selector: 'app-content-block-faq',
    imports: [FaqSectionComponent],
    templateUrl: './content-block-faq.component.html',
    styleUrl: './content-block-faq.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentBlockFaqComponent extends ContentBlockBaseComponent {
  // faq$ = signal(groupFaqs(exampleFaqs));
  // faqSectionTitle = Object.keys(this.faq$())[0];
  // faqSection$ = computed(() => {
  //   return this.faq$()[this.faqSectionTitle];
  // });

  faq$ = computed(() => {
    return this.block().faq?.reduce((acc: { [key: string]: { [key: string]: FaqItem[] } }, cur) => {
      const depName = cur.category.department?.name;
      const catName = cur.category.name;
      if (!acc[depName]) {
        acc[depName] = {};
      }
      if (!acc[depName][catName]) {
        acc[depName][catName] = [];
      }
      acc[depName][catName].push(cur);
      return acc;
    }, {});
  });

  faqArray$ = computed(() => {
    return (this.block().faq || []).reduce((acc: { [key: string]: FaqItem[] }, cur) => {
      const depName = cur.category.department?.name;
      const catName = cur.category.name;

      const groupName = depName + ' - ' + catName;

      if (!acc[groupName]) {
        acc[groupName] = [];
      }
      acc[groupName].push(cur);

      return acc;
    }, {});
  });

  faqSectionTitle = computed(() => {
    return Object.keys(this.faq$() ?? {})[0];
  });

  faqSection$ = computed(() => {
    const faq = this.faq$();
    const faqSectionTitle = this.faqSectionTitle();
    return faq && faqSectionTitle ? faq[faqSectionTitle] ?? {} : {};
  });
}
